import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import FloatingLeadCapture from "@/components/FloatingLeadCapture";
import HomePage from "@/pages/HomePage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import ProductPage from "@/pages/ProductPage";
import QrKitPage from "@/pages/QrKitPage";
import FeaturesPage from "@/pages/FeaturesPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import LinkGeneratorPage from "@/pages/LinkGeneratorPage";
import IndustryPage from "@/pages/IndustryPage";
import DocsPage from "@/pages/DocsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ScrollToTop from "@/components/ScrollToTop";
import "@/App.css";

function App() {
  return (
    <div className="App font-body bg-white text-slate-900 min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/tools/whatsapp-link-generator" element={<LinkGeneratorPage />} />
            <Route path="/products/qr-kits" element={<QrKitPage />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/industries/:slug" element={<IndustryPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <FloatingLeadCapture />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
